

























































































import { Component, Model, Prop, Vue } from "vue-property-decorator";
import { ActionSheet, Swipe, SwipeItem, NumberKeyboard, Toast } from "vant";
import Selector from "@/components/Selector.vue";
import { createAnimation } from "@/components/giftAnimation/index";
import { needToken } from "@/common/decorator";
import request from "@/api/index";
import { IGiftItem } from "@/api/types";
@Component({
  components: {
    [ActionSheet.name]: ActionSheet,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [NumberKeyboard.name]: NumberKeyboard,
    Selector
  },
  filters: {
    showIntegral(i: number) {
      if (i === 0) {
        return "免费";
      } else {
        return `积分  ${i}`;
      }
    }
  }
})
export default class Gift extends Vue {
  @Prop()
  @Model("show")
  show!: boolean;

  @Prop()
  list!: IGiftItem[];

  integral = "--";

  showSelector = false;

  showKeyBoard = false;

  giftList: IGiftItem[][] = [];

  currentItem: IGiftItem | null = null;
  currentNum = 1;
  keyBoardNum = "";

  get showValue() {
    return this.show;
  }

  set showValue(value: boolean) {
    if (!value) {
      this.init();
    }
    this.$emit("show", value);
  }

  /**
   * 赠送按钮是否可交互
   */
  get buttonDisabled() {
    return this.currentItem === null;
  }

  mounted() {
    this.setGiftList();
  }

  init() {
    this.currentItem = null;
    this.currentNum = 1;
  }

  /** 获取礼物列表 */
  setGiftList() {
    const pageLength = 8;
    for (let i = 0; i < this.list.length; i += pageLength) {
      const page = this.list.slice(i, i + pageLength);
      page.length = pageLength;
      this.giftList.push(page);
    }
  }

  keyBoardClosed() {
    this.keyBoardNum = "";
  }

  inputOver() {
    const number = Number(this.keyBoardNum);
    if (!isNaN(number)) {
      this.currentNum = number;
    }
    this.showKeyBoard = false;
  }

  itemClick(item: IGiftItem) {
    if (item) {
      this.currentItem = item;
    }
  }

  setNum(num: number) {
    if (num > 0) {
      this.currentNum = num;
    } else {
      this.showKeyBoard = true;
    }
  }

  /** 赠送礼物 */
  @needToken(true, true)
  async sendGift() {
    if (this.buttonDisabled) return;
    if (this.currentNum * this.currentItem!.pointSum > Number(this.integral)) {
      Toast("积分余额不足");
    } else {
      const result = await request.liveExchange(
        this.currentItem!.id,
        this.currentNum,
        this.$store.state.detail.informationId,
        this.$store.state.detail.title
      );
      console.log("赠送礼物结果：", result);
      if (result.code === 0) {
        createAnimation(
          this.currentItem!.giftGif,
          this.currentNum,
          Number(this.currentItem?.showTime) * 1000
        );
      } else {
        Toast(result.message);
      }
      this.showValue = false;
    }
  }

  /** 获取可用总积分 */
  @needToken(false)
  async getLivePoint() {
    const result = await request.livePoint();
    if (typeof result.data === "number") {
      this.integral = result.data + "";
    }
  }

  record() {
    this.$router.push("/record");
  }
}
